export interface Lead {
  id: number;
  key:number;
  si_no:any;
  select:any;
  phone:any;
  customer_name:string;
  customer_no:string;
  image:string;
  email:string;
  role:string;
  department:string;
  created:string;
  last_activity:string;
  status:string;
  Pirority:string;
  Action:string;
}
export const leadsData:Lead[] = [
  {
    id: 1,
    key: 1,
    si_no: "",
    select: "",
    customer_name: "Darlee Robertson",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Facility Manager",
    phone: "+1 (847) 34567890",
    email: "robertson@gamil.com",
    role: "client",
    department: "Client",
    created: "25 Sep 2023, 12:12 pm",
    last_activity: "2 mins ago",
    status: "Active",
    Pirority: "Low",
    Action: "",
  },
  {
    id: 2,
    key: 2,
    si_no: "",
    select: "",
    customer_name: "Sharon Roy",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Installer",
    phone: "+1 (847) 989757485",
    email: "sharon@gamil.com",
    role:"Manager",
    department: "Finance Department",
    created: "27 Sep 2023, 07:40 am",
    last_activity: "5 mins ago",
    status: "Inactive",
    Pirority: "High",
    Action: "",
  },
  {
    id: 3,
    key: 3,
    si_no: "",
    select: "",
    customer_name: "Vaughan",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Senior  Manager",
    phone: "+1 (847) 546555455",
    email: "vaughan12@gamil.com",
    role:"Org Admin",
    department: "Sales Department",
    created: "29 Sep 2023, 08:20 am",
    last_activity: "2 days ago",
    status: "Active",
    Pirority: "Medium",
    Action: "",
  },
  {
    id: 4,
    key: 4,
    si_no: "",
    select: "",
    customer_name: "Jessica",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Test Engineer",
    phone: "+1 (847) 454478787",
    email: "jessica13@gamil.com",
    role:"Sales Manager",
    department: "Sales Department",
    created: "25 Sep 2023, 12:12 pm",
    last_activity: "2 mins ago",
    status: "Active",
    Pirority: "Low",
    Action: "",
  },
  {
    id: 5,
    key: 5,
    si_no: "",
    select: "",
    customer_name: "Carol Thomas",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "UI /UX Designer",
    phone: "+1 (847) 124547845",
    email: "caroltho3@gamil.com",
    role:"Project Manager",
    department: "Sales Department",
    created: "02 Oct 2023, 10:10 am",
    last_activity: "Online",
    status: "Active",
    Pirority: "High",
    Action: "",
  },
  {
    id: 6,
    key: 6,
    si_no: "",
    select: "",
    customer_name: "Dawn Mercha",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Technician",
    phone: "+1 (847) 478845447",
    email: "dawnmercha@gamil.com",
    role:"Sales Manager",
    department: "PDM Department",
    created: "17 Oct 2023, 04:25 pm",
    last_activity: "3 days ago",
    status: "Active",
    Pirority: "Low",
    Action: "",
  },
  {
    id: 7,
    key: 7,
    si_no: "",
    select: "",
    customer_name: "Rachel Hampton",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Software Developer",
    phone: "+1 (847) 215544845",
    email: "rachel@gamil.com",
    role:"Manager",
    department: "PDM Department",
    created: "28 Oct 2023, 07:16 am",
    last_activity: "10 days ago",
    status: "Active",
    Pirority: "Medium",
    Action: "",
  },
  {
    id: 8,
    key: 8,
    si_no: "",
    select: "",
    customer_name: "Jonelle Curtiss",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Supervisor",
    phone: "+1 (847) 121145471",
    email: "jonelle@gamil.com",
    role:"Manager",
    department: "PDM Department",
    created: "08 Nov 2023, 06:10 am",
    last_activity: "1 week go",
    status: "Active",
    Pirority: "Low",
    Action: "",
  },
  {
    id: 9,
    key: 9,
    si_no: "",
    select: "",
    customer_name: "Jonathan",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Team Lead Dev",
    phone: "+1 (847) 321454789",
    email: "jonathan@gamil.com",
    role:"Client",
    department: "PDM Department",
    created: "15 Nov 2023, 11:50 am",
    last_activity: "1 day ago",
    status: "Active",
    Pirority: "High",
    Action: "",
  },
  {
    id: 10,
    key: 10,
    si_no: "",
    select: "",
    customer_name: "Brook",
    image: "assets/img/profiles/profile-img.jpg",
    customer_no: "Team Lead Dev ",
    phone: "+1 (847) 278907145",
    email: "brook@gamil.com",
    role:"Manager",
    department: "PDM Department",
    created: "25 Nov 2023, 06:34 pm",
    last_activity: "8 mins ago",
    status: "Active",
    Pirority: "Medium",
    Action: "",
  },
];
